import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import selectDownArrow from "../../../assets/images/selectDownArrow.svg";

const VEHICLE_OPTIONS = [
  { value: "BICYCLE", label: "Bicycle" },
  { value: "MOTORCYCLE", label: "Motorcycle" },
  { value: "TRICYCLE", label: "Tricycle" },
  { value: "SUV", label: "SUV" },
  { value: "CAR", label: "Sedan" },
  { value: "VAN", label: "Van" },
  { value: "SMALL_TRUCK", label: "Small Truck" },
  { value: "MEDIUM_TRUCK", label: "Medium Truck" },
  { value: "LARGE_TRUCK", label: "Large Truck" },
  { value: "TRAILER", label: "Small Trailer" },
  { value: "FULL_TRAILER", label: "Full Trailer" },
];

const INTERSTATE_EXCLUDED_VEHICLES = ["BICYCLE", "MOTORCYCLE"];

class VehicleTypeSelect extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false, dropdownStyle: {} };
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
    window.removeEventListener("resize", this.updateDropdownStyle);
  }

  handleOutsideClick = (e) => {
    if (
      this.containerRef.current &&
      !this.containerRef.current.contains(e.target)
    ) {
      this.closeDropdown();
    }
  };

  openDropdown = () => {
    this.setState({ open: true }, () => {
      this.updateDropdownStyle();
      window.addEventListener("resize", this.updateDropdownStyle);
    });
  };

  closeDropdown = () => {
    this.setState({ open: false, dropdownStyle: {} }, () => {
      window.removeEventListener("resize", this.updateDropdownStyle);
    });
  };

  handleToggleOpen = () => {
    if (this.state.open) this.closeDropdown();
    else this.openDropdown();
  };

  updateDropdownStyle = () => {
    const el = this.containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const vw = window.innerWidth || document.documentElement.clientWidth;
    const vh = window.innerHeight || document.documentElement.clientHeight;

    const style = {};
    const margin = 12;

    const maxWidth = Math.min(rect.width, vw - margin * 2);
    style.maxWidth = `${maxWidth}px`;

    const availableRight = vw - rect.left - margin;
    if (maxWidth > availableRight) {
      style.right = "0";
      style.left = "auto";
    } else {
      style.left = "0";
      style.right = "auto";
    }

    const availableBelow = vh - rect.bottom - margin;
    const maxHeight = Math.max(Math.min(availableBelow, 400), 120);
    style.maxHeight = `${maxHeight}px`;
    style.overflowY = "auto";

    this.setState({ dropdownStyle: style });
  };

  getFilteredOptions = () => {
    const { isInterstate, requestType } = this.props;
    const isInterstateDelivery = isInterstate || requestType === "INTERSTATE";

    if (isInterstateDelivery) {
      return VEHICLE_OPTIONS.filter(
        (opt) => !INTERSTATE_EXCLUDED_VEHICLES.includes(opt.value),
      );
    }
    return VEHICLE_OPTIONS;
  };

  toggle = (value) => {
    const current = this.props.selected || [];
    const next = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];
    this.props.onChange(next);
  };

  getDisplayText() {
    const selected = this.props.selected || [];
    const options = this.getFilteredOptions();

    const activeSelected = selected.filter((v) =>
      options.some((o) => o.value === v),
    );

    if (activeSelected.length === 0) return "Select vehicle type";
    return activeSelected
      .map((v) => options.find((o) => o.value === v)?.label || v)
      .join(", ");
  }

  render() {
    const { selected = [] } = this.props;
    const { open } = this.state;
    const options = this.getFilteredOptions();

    return (
      <div className="country-dropdown-wrapper" ref={this.containerRef}>
        <InputGroup
          className={`country-search-box`}
          onClick={this.handleToggleOpen}
        >
          <Form.Control
            type="text"
            className="country-input"
            placeholder="Select vehicle type"
            value={this.getDisplayText()}
            readOnly
          />
          <InputGroup.Text
            className="dropdown-arrow-wrapper"
            onClick={(e) => {
              e.stopPropagation();
              this.openDropdown();
            }}
            style={{ backgroundColor: "transparent", border: "none" }}
          >
            <img
              src={selectDownArrow}
              alt="CaretDown"
              className="dropdown-arrow"
            />
          </InputGroup.Text>
        </InputGroup>

        {open && (
          <div
            className="country-dropdown-list"
            style={this.state.dropdownStyle}
          >
            {options.map((opt) => {
              const checked = selected.includes(opt.value);
              return (
                <div
                  key={opt.value}
                  className={`country-option`}
                  onClick={() => this.toggle(opt.value)}
                >
                  <input
                    type="checkbox"
                    checked={checked}
                    readOnly
                    style={{ marginRight: 8 }}
                  />
                  <span>{opt.label}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

export default VehicleTypeSelect;
